export default {
  createQuoteSuccess: 'Quote created! It will be ready in 30 seconds.',
  createQuoteFailure: 'Opps, something went wrong. Check your locations and date.',
  updateQuoteSuccess: 'Quote updated! It will be ready in 30 seconds.',
  updateQuoteFailure: 'Opps, something went wrong. Check your locations and date.',
  deleteQuoteSuccess: 'Quote deleted!',
  deleteQuoteFailure: 'Opps, something went wrong. Try again.!'
}



// WEBPACK FOOTER //
// ./src/quote/messages.js